// extracted by mini-css-extract-plugin
export default {"groupElementsContainer":"group-permissions-editor_groupElementsContainer__nv0TM"};